export const onlyForDev = process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'development'
export const onlyForLocal = process.env.REACT_APP_ENV === 'local'
